{
  "Accessibility Menu": "رسائی مینو",
  "Reset settings": "ترتیبات ری سیٹ کریں",
  "Close": "بند کریں",
  "Content Adjustments": "مواد کی ایڈجسٹمنٹ",
  "Adjust Font Size": "فونٹ سائز ایڈجسٹ کریں",
  "Highlight Title": "عنوان کو نمایاں کریں",
  "Highlight Links": "لنکس کو نمایاں کریں",
  "Readable Font": "قابلِ مطالعہ فونٹ",
  "Color Adjustments": "رنگ کی ایڈجسٹمنٹ",
  "Dark Contrast": "گہرا تضاد",
  "Light Contrast": "ہلکا تضاد",
  "High Contrast": "زیادہ تضاد",
  "High Saturation": "زیادہ سیچوریشن",
  "Low Saturation": "کم سیچوریشن",
  "Monochrome": "مونوکروم",
  "Contrast": "کنٹراسٹ",
  "Invert Colors": "رنگ الٹا کریں",
  "Tools": "اوزار",
  "Reading Guide": "مطالعہ گائیڈ",
  "Stop Animations": "حرکات روکیں",
  "Big Cursor": "بڑا کرسر",
  "Increase Font Size": "فونٹ سائز بڑھائیں",
  "Decrease Font Size": "فونٹ سائز کم کریں",
  "Letter Spacing": "حروف کا فاصلہ",
  "Line Height": "لائن کی اونچائی",
  "Font Weight": "فونٹ کا وزن",
  "Dyslexia Font": "ڈسلیکسیا فونٹ",
  "Language": "زبان",
  "Open Accessibility Menu": "رسائی مینو کھولیں",
  "Widget Settings": "ویجیٹ سیٹنگز",
  "Widget Position": "ویجیٹ کی پوزیشن",
  "Top Left": "اوپر بائیں",
  "Top Center": "اوپر درمیان",
  "Top Right": "اوپر دائیں",
  "Center Left": "درمیان بائیں",
  "Center Right": "درمیان دائیں",
  "Bottom Left": "نیچے بائیں",
  "Bottom Center": "نیچے درمیان",
  "Bottom Right": "نیچے دائیں",
  "Screen Reader": "اسکرین ریڈر",
  "Voice Navigation": "آواز کی نیویگیشن",
  "Custom Color": "مخصوص رنگ",
  "Change the site's colors": "سائٹ کے رنگ تبدیل کریں",
  "Backgrounds": "پس منظر",
  "Headings": "سرخیاں",
  "Contents": "مواد",
  "Reset colors": "رنگ دوبارہ سیٹ کریں",
  "Image Desaturation": "تصویر کا رنگ کم کریں",
  "Search languages": "زبانیں تلاش کریں",
  "No languages found": "کوئی زبان نہیں ملی",
  "Accessibility Profiles": "رسائی کے پروفائل",
  "Motor Impaired": "حرکتی معذوری",
  "Big cursor, voice navigation, and no animations.": "بڑا کرسر، آواز کے ذریعے نیویگیشن اور کوئی اینیمیشن نہیں۔",
  "Blind": "نابینا",
  "Screen reader helpers with higher contrast.": "زیادہ کنٹراسٹ والے اسکرین ریڈر مددگار۔",
  "Color Blind": "رنگوں کی کمزوری",
  "High contrast palette with desaturated media.": "زیادہ کنٹراسٹ والی پیلیٹ اور مدھم میڈیا۔",
  "Dyslexia": "ڈسلیکسیا",
  "Friendly font, extra spacing, stronger weight.": "آسان فونٹ، اضافی فاصلہ اور زیادہ موٹائی۔",
  "Low vision": "کمزور بینائی",
  "Dark contrast and 130% magnification.": "گہرے کنٹراسٹ اور 130٪ بڑا کرنا۔",
  "Cognitive & Learning": "ادراکی اور تعلیم",
  "Highlights key sections and enables voice help.": "اہم حصوں کو نمایاں کرتا ہے اور آواز کی مدد کو فعال کرتا ہے۔",
  "Seizure & Epileptic": "دورہ اور مرگی",
  "Stops animations and desaturates imagery.": "اینیمیشنز روکتا ہے اور تصاویر کی رنگت کم کرتا ہے۔",
  "ADHD": "اے ڈی ایچ ڈی",
  "Reading guide, highlighted links, calmer palette.": "مطالعہ رہنمائی، نمایاں روابط اور پُرسکون رنگ۔",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
